import React from 'react';
import { Outlet } from 'react-router-dom';
import './Main.css';

export default function Main(props) {
    return (
        <Outlet />
    );
}